import React, { useState } from 'react'
import Footer from '../../CoreComponents/Footer'
import Header from '../../CoreComponents/Header'
import MainHeader from '../../CoreComponents/MainHeader'
import NavBar from '../../CoreComponents/NavBar'
import { is_franchise_admin, is_franchise_manager, is_franchise_staff } from '../../Functionalities/Config'
import { showMessage } from '../../Functionalities/Functions'
import { validateEmail } from '../../Functionalities/Validation'
import { ManageManagers } from './Logic'


const USER_TYPE_KEYWORDS = { staff: 'add_franchise_staffs', accountant: 'add_franchise_accountant' }
const ADDED = { add_franchise_staffs: 'a staff user', add_franchise_accountant: 'an accountant' }

function Body() {
    const [disable, setdisable] = useState(false)
    const is_franchise_user = is_franchise_admin || is_franchise_manager || is_franchise_staff
    const [data, setData] = useState({
        user_type: "manager",
        name: "",
        username: "",
        password: "",
        confirm_password: "",
        email: "",
        mobile: "",
        address1: "",
        address2: "",
        land_mark: "",
        latitude: 0.0,
        longitude: 0.0,
        city: "",
        pin: "",
        state: "",
        // images:""
    })
    return (
        <div class="content-body">
            <div class="container-fluid">
                <div class="page-titles">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a href="javascript:void(0)">Manager</a>
                        </li>
                        <li class="breadcrumb-item active">
                            <a href="javascript:void(0)">Manager</a>
                        </li>
                    </ol>
                </div>
                <div className="col-xl-12 col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Manager</h4>
                        </div>
                        <div className="card-body">

                            <div className="basic-form">
                                <form>
                                    {is_franchise_user && (
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">User type<span className="required">*</span></label>
                                            <div className="col-sm-9">
                                                <select className="form-control"
                                                    value={data.user_type}
                                                    onChange={
                                                        (e) => {
                                                            setData({ ...data, user_type: e.target.value })
                                                        }
                                                    }
                                                >
                                                    <option value="manager">Manager</option>
                                                    <option value="staff">Staff (limited access)</option>
                                                    <option value="accountant">Accountant (reports and delivery boys only)</option>
                                                </select>
                                            </div>
                                        </div>
                                    )}
                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label">Name<span className="required">*</span></label>
                                        <div className="col-sm-9">
                                            <input type="text" className="form-control"
                                                value={data.name}
                                                onChange={
                                                    (e) => {
                                                        setData({ ...data, name: e.target.value })
                                                    }
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label">Username<span className="required">*</span></label>
                                        <div className="col-sm-9">
                                            <input type="text" className="form-control"
                                                value={data.username}
                                                onChange={
                                                    (e) => {
                                                        setData({ ...data, username: e.target.value })
                                                    }
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label">Password<span className="required">*</span></label>
                                        <div className="col-sm-9">
                                            <input type="password" className="form-control"
                                                value={data.password}
                                                onChange={
                                                    (e) => {
                                                        setData({ ...data, password: e.target.value })
                                                    }
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label">Confirm Password<span className="required">*</span></label>
                                        <div className="col-sm-9">
                                            <input type="password" className="form-control"
                                                value={data.confirm_password}
                                                onChange={
                                                    (e) => {
                                                        setData({ ...data, confirm_password: e.target.value })
                                                    }
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label">Email
                                        {/* <span className="required">*</span> */}
                                        </label>
                                        <div className="col-sm-9">
                                            <input type="text" className="form-control"
                                                value={data.email}
                                                onChange={
                                                    (e) => {
                                                        setData({ ...data, email: e.target.value })
                                                    }
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label">Mobile<span className="required">*</span></label>
                                        <div className="col-sm-9">
                                            <input type="number" className="form-control"
                                                value={data.mobile}
                                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                                onWheelCapture={e => {e.target.blur()}}
                                                onChange={(e) => {setData({ ...data, mobile: e.target.value.slice(0, 10) })}}
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="form-group row">
                                        <label className="col-sm-3 col-form-label">Address<span className="required">*</span></label>
                                        <div className="col-sm-9">
                                            <input type="text" className="form-control"
                                                value={data.address1}
                                                onChange={
                                                    (e) => {
                                                        setData({ ...data, address1: e.target.value })
                                                    }
                                                }
                                            />
                                        </div>
                                    </div> */}

                                    <div className="form-group row">

                                        <div className="col-sm-9">
                                            <button disabled={disable} type='submit' className="btn btn-primary"
                                                onClick={
                                                    (e) => {
                                                        e.preventDefault()
                                                        setdisable(true)
                                                        if (data.name === "") {
                                                            setdisable(false)
                                                            showMessage("Name is required", "danger", "Error!", "top", "top-right", 0)
                                                            return
                                                        }
                                                        if (data.username === "") {
                                                            setdisable(false)
                                                            showMessage("Username is required", "danger", "Error!", "top", "top-right", 0)
                                                            return
                                                        }
                                                        if (data.password === "") {
                                                            setdisable(false)
                                                            showMessage("Password is required", "danger", "Error!", "top", "top-right", 0)
                                                            return
                                                        }
                                                        if (data.password.length < 5) {
                                                            setdisable(false)
                                                            showMessage("Passwords must be atleast 5 characters", "danger", "Error!", "top", "top - right", 0)
                                                            return
                                                        }
                                                        if (data.password !== data.confirm_password) {
                                                            setdisable(false)
                                                            // void 0
                                                            showMessage("Passwords do not match", "danger", "Error!", "top", "top-right", 0)
                                                            return
                                                        }
                                                        // if (data.email === "") {
                                                        //     setdisable(false)
                                                        //     showMessage("Email required", "danger", "Error!", "top", "top-right", 0)
                                                        //     return
                                                        // }
                                                        // if (validateEmail(data.email) === false) {
                                                        //     setdisable(false)
                                                        //     showMessage("Please enter a valid email", "danger", "Error!", "top", "top-right", 0)
                                                        //     return
                                                        // }
                                                        if (data.mobile === "") {
                                                            setdisable(false)
                                                            showMessage("Mobile required", "danger", "Error!", "top", "top-right", 0)
                                                            return
                                                        }
                                                        if (data.mobile.length < 10) {
                                                            setdisable(false)
                                                            showMessage("Mobile number should be 10 digits", "danger", "Error!", "top", "top-right", 0)
                                                            return
                                                        }
                                                        // if (data.address1 === "") {
                                                        //     setdisable(false)
                                                        //     showMessage("Address required", "danger", "Error!", "top", "top-right", 0)
                                                        //     return
                                                        // }

                                                        const keyword = is_franchise_user
                                                            ? USER_TYPE_KEYWORDS[data.user_type] || 'add_franchise_manager'
                                                            : 'add'
                                                        let result = ManageManagers(e, data, keyword, '')
                                                        result.then(result => {
                                                            setdisable(false)

                                                            if (result.data.Status) {
                                                                // alert('successfully added a manager')
                                                                showMessage(`successfully added ${ADDED[keyword] || 'a manager'}`, "success", "Success!", "top", "top-right", 0)
                                                                // window.location.reload()
                                                            }
                                                            else {
                                                                //    alert(`${result.data.Error}`)
                                                                showMessage(`${result.data.Error}`, "danger", "failed", "top", "top-right", 0)
                                                            }
                                                        }).catch(err => {
                                                        })
                                                    }
                                                }
                                            >Save
                                        </button>
                                        </div>

                                    </div>


                                </form>

                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}


function AddManager() {

    const headers = 'Add Manager'

    return (
        <div>
            <div id="main-wrapper">
                <MainHeader />
                <Header name={headers} />
                <NavBar /> {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
                <Body />
                <Footer />
            </div>
        </div>
    )
}

export default AddManager
